import { groupAccentCssVar } from "../workspace/groupColors";
import type { GroupColorSlot } from "../workspace/workspace.types";

export const COLOR_DOT_SIZE = {
  display: "inline-block",
  width: 10,
  height: 10,
  borderRadius: 999,
  flexShrink: 0,
} as const;

export const ColorDot = ({
  colorSlot,
  hollow = false,
}: {
  colorSlot?: GroupColorSlot;
  hollow?: boolean;
}) => (
  <span
    aria-hidden
    data-testid={hollow ? "group-dot-hollow" : "group-dot-filled"}
    style={
      hollow
        ? {
            ...COLOR_DOT_SIZE,
            border: "1.5px solid var(--gray-8)",
            backgroundColor: "transparent",
          }
        : {
            ...COLOR_DOT_SIZE,
            backgroundColor: groupAccentCssVar(colorSlot ?? "blue"),
          }
    }
  />
);
